module.exports = __webpack_public_path__ + "static/img/call_flow_type_all.79deb607.svg";